import { FacetTypes } from "../constants/facet-types-enum";
import { FacetBase } from "../models/facet-base/facet-base";
import { FacetAppState } from "../models/state/facet-app-state";
import { FacetStateValues } from "../models/state/facet-state-values";
import { NumberFacet } from "../models/facets/number-facet";
import { RangeFacetValues } from "../models/facet-values/range-facet-values";

import { TextFacet } from "../models/facets/text-facet";
import { TextFacetValue } from "../models/facet-values/text-facet-value";
import { RangeValues } from "../models/types/type-range-values";

//Toggle a facet as selected/deselected
export const getNewSelectedFacetValues = (
	selectedFacets: FacetStateValues,
	initialFacets: FacetStateValues,
	facet: FacetBase,
	facetValue: string[] | number | RangeValues,
): FacetStateValues => {
	switch (facet.type) {
		//For ranges we just want to write the passed in object to redux, this includes the
		// selected value as well as the high and low values for the overall range.
		case FacetTypes.Range:
			let rangeValue = facetValue as RangeValues;

			//If the value is the whole range then remove it as selected, otherwise the
			//call for info items will be displayed in the wrong list.
			let newLowValue = rangeValue[0];
			let newHighValue = rangeValue[1];

			let initialFacetValues = initialFacets[facet.fieldName];

			if (initialFacetValues !== null && initialFacetValues !== undefined) {
				if (
					newLowValue === initialFacetValues[0] &&
					newHighValue === initialFacetValues[1]
				) {
					if (
						selectedFacets[facet.fieldName] !== null &&
						selectedFacets[facet.fieldName] !== undefined
					) {
						delete selectedFacets[facet.fieldName];
					}
				} else {
					selectedFacets[facet.fieldName] = [rangeValue[0], rangeValue[1]];
				}
			} else {
				selectedFacets[facet.fieldName] = [rangeValue[0], rangeValue[1]];
			}

			break;

		//For numbers, if the number does not exist in redux then write it
		// other wise the user has unselected the number so we need to remove it from redux.
		case FacetTypes.Number:
			var currentSelectedNumber = selectedFacets[facet.fieldName] as number;

			if (currentSelectedNumber) {
				if (currentSelectedNumber !== facetValue) {
					selectedFacets[facet.fieldName] = facetValue;
				} else {
					delete selectedFacets[facet.fieldName];
				}
			} else {
				selectedFacets[facet.fieldName] = facetValue;
			}

			break;

		case FacetTypes.Text:
			var currentSelectedTextValues = selectedFacets[
				facet.fieldName
			] as string[];

			var newTextFacetValue = facetValue as string[];

			//Check to see if the facet is already in redux, if it is we want to add any new
			// values and remove any values that are already selected (i.e. toggling)
			if (currentSelectedTextValues) {
				var selections = [...currentSelectedTextValues];

				newTextFacetValue.forEach((newValue) => {
					if (selections.includes(newValue)) {
						selections = selections.filter((f) => f !== newValue);
					} else {
						selections.push(newValue);
					}
				});

				//If there are no selections remove the facet from redux
				if (selections.length === 0) {
					delete selectedFacets[facet.fieldName];
				} else {
					selectedFacets[facet.fieldName] = selections as string[];
				}
			}
			//If the facet is not already in redux write the passed in object to redux
			else {
				selectedFacets[facet.fieldName] = newTextFacetValue;
			}

			break;
	}

	return selectedFacets;
};
